<template>
  <div class="history__div--box">
    <div class="history__div--tag">
      <el-tag
        closable
        style="margin-right: 4px"
        v-for="(item, index) in history"
        @click="historyClick(item)"
        @close="close(item, index)"
        :type="item.isActive ? 'success' : 'info'"
        :key="item.path"
        >{{ item.meta.name }}</el-tag
      >
    </div>
  </div>
</template>

<script>
import store from "@/store";
export default {
  name: "PageHistory",
  data() {
    return {
      history: [],
    };
  },
  watch: {
    $route: {
      handler: function (newVal) {
        const flag = this.history.some((item) => item.path === newVal.path);
        if (flag) {
          this.history.forEach((item) => {
            item.isActive = item.path === newVal.path;
          });
        } else {
          this.history.forEach((item) => {
            item.isActive = false;
          });
          if (!newVal.fullPath.includes("/auth")) {
            this.history.push({
              ...newVal,
              isActive: true,
            });
          }
        }
        if (this.history.length > 12) {
          this.history = this.history.slice(this.history.length - 12);
        }
        // console.log(newVal)
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    close: function (item, index) {
      const _nowPath = this.$route.path;
      const _name = this.$route.name
      if (this.history.length === 1) {
        return;
      }
      if (item.path === _nowPath) {
        const _index = index > 0 ? index - 1 : index + 1;
        this.$router.push(this.history[_index].path);
      }
      this.history.splice(index, 1);
      this.$store.commit('setKeepAliveLists',_name)
    },
    historyClick(item) {
      let parentId = item.meta.parentId;
      store.getters.getMenus.forEach((item) => {
        if (parentId && item.id === parentId) {
          store.dispatch("menu/changeMenu", item);
        }
      });
      this.$router.push(item.path);
    },
  }
};
</script>

<style scoped>
.history__div--box {
  min-width: 1000px;
  position: sticky;
  top: 0px;
  left: 0;
  background-color: rgb(84, 92, 100);
  height: 40px;
  margin: 0 10px;
  border-radius: 0 0 12px 12px;
  border-top: 1px solid rgb(84, 92, 100);
  z-index: 999;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 5px 12px 6px;
}
/*.history__div--tag {*/
/*  !*margin: 7px 8px 8px;*!*/
/*  !*border-radius: 10px;*!*/
/*  height: 44px;*/
/*  !*background: #adadad;*!*/
/*  display: flex;*/
/*  justify-content: flex-start;*/
/*  align-items: center;*/
/*  padding: 0 10px;*/
/*}*/
.history__div--box::before {
  display: block;
  content: "";
  width: 6px;
  height: 6px;
  position: absolute;
  top: -1px;
  right: -6px;
  /*background-color: rgb(27, 122, 217);*/
  background: radial-gradient(
    circle at 0% 0%,
    transparent 6px,
    rgb(84, 92, 100) 0
  );
  transform: rotate(180deg);
}
.history__div--box::after {
  display: block;
  content: "";
  width: 6px;
  height: 6px;
  position: absolute;
  top: -1px;
  left: -6px;
  /*background-color: rgb(27, 122, 217);*/
  background: radial-gradient(
    circle at 0% 0%,
    transparent 6px,
    rgb(84, 92, 100) 0
  );
  transform: rotate(-90deg);
}
::v-deep .el-tag {
  font-weight: 600;
  font-size: 14px;
  line-height: 32px;
  height: 32px;
}
</style>
